import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRoboto, theme } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  align-items: center;
  border-inline-end: 1px solid #333333;
`;

export const EpaperLinkList = styled(BaseLink)`
  inline-size: 89px;
  padding-inline: 16px;

  color: #2c4692;
  font-size: 12px;
  font-family: ${fontRoboto};
  white-space: nowrap;

  border-radius: 4px 4px 0 0;

  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }

  ${theme.breakpoints.up("desktop")} {
    padding-inline: 24px;
  }
`;
